const CardData = [
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "26.11.2022",
    distance: 7,
    link: "https://www.strava.com/activities/8170544632",
    weather: "0°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "24.11.2022",
    distance: 5,
    link: "https://www.strava.com/activities/8162293609",
    weather: "1°C 🌨️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "21.11.2022",
    distance: 5,
    link: "https://www.strava.com/activities/8150114441",
    weather: "-1°C ☁️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "10.11.2022",
    distance: 6,
    link: "https://www.strava.com/activities/8098419282",
    weather: "10°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "02.11.2022",
    distance: 6,
    link: "https://www.strava.com/activities/8098419282",
    weather: "11°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "30.10.2022",
    distance: 7,
    link: "https://www.strava.com/activities/8042872938?source=global-footer",
    weather: "5°C ☁️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "29.10.2022",
    distance: 6,
    link: "https://www.strava.com/activities/8035831156?source=global-footer",
    weather: "8°C ☀️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "26.10.2022",
    distance: 5,
    link: "https://www.strava.com/activities/8020577562",
    weather: "4°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "24.10.2022",
    distance: 8,
    link: "https://www.strava.com/activities/8013159274",
    weather: "5°C 🌧️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "22.10.2022",
    distance: 6,
    link: "https://www.strava.com/activities/8001286565",
    weather: "6°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "20.10.2022",
    distance: 8,
    link: "https://www.strava.com/activities/7990814553",
    weather: "2°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "18.10.2022",
    distance: 9,
    link: "https://www.strava.com/activities/7983448509",
    weather: "3°C 🌙",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "16.10.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7970086877",
    weather: "7°C 🌧️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "15.10.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7965272419",
    weather: "9°C ☀️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "13.10.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7955249816",
    weather: "5°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "12.10.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7949992680",
    weather: "1°C 🌙",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "08.10.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7929724133",
    weather: "9°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "07.10.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7926309237",
    weather: "8°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "04.10.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7911516170",
    weather: "12°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "30.09.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7890123790",
    weather: "8°C ☁️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "29.09.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7884938500",
    weather: "9°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "25.09.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7864233545",
    weather: "13°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "20.09.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7838870632",
    weather: "10°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "20.09.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7834560397",
    weather: "7°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "18.09.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7828905301",
    weather: "14°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "15.09.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7813381733",
    weather: "13°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "12.09.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7794307310",
    weather: "13°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "09.09.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7778390975",
    weather: "15°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "06.09.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7764960483",
    weather: "16°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "05.09.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7760059605",
    weather: "15°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "31.08.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7732509141",
    weather: "18°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "29.08.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7721875226",
    weather: "16°C 🌙",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "28.08.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7712329059",
    weather: "20°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "25.08.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7696899013",
    weather: "22°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "24.08.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7691319315",
    weather: "24°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "21.08.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7673409628",
    weather: "25°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "14.08.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7636740494",
    weather: "28°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "13.08.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7628972972",
    weather: "27°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "11.08.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7620779656",
    weather: "26°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "27.07.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7535670003",
    weather: "23°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "26.07.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7532359155",
    weather: "22°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "25.07.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7525338818",
    weather: "20°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "20.07.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7498935134",
    weather: "22°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "19.07.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7493503974",
    weather: "25°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "18.07.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7487808248",
    weather: "23°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "10.07.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7444468317",
    weather: "20°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "09.07.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7438845012",
    weather: "24°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "08.07.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7434395297",
    weather: "26°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "04.07.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7412420715",
    weather: "22°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "03.07.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7407792483",
    weather: "23°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "02.07.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7402749262",
    weather: "24°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "30.06.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7392248438",
    weather: "26°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "27.06.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7376027705",
    weather: "21°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "26.06.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7370907689",
    weather: "23°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "25.06.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7363991694",
    weather: "25°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "23.06.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7355253981",
    weather: "27°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "21.06.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7343835874",
    weather: "21°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "19.06.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7333488279",
    weather: "18°C ⛅",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "18.06.2022",
    distance: 8,
    link: "https://www.strava.com/activities/7326851891",
    weather: "17°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "16.06.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7317523925",
    weather: "20°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "10.06.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7284829299",
    weather: "24°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "08.06.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7275687015",
    weather: "21°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "08.06.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7270118390",
    weather: "18°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "06.06.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7263292578",
    weather: "20°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "04.06.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7253443151",
    weather: "21°C ☀️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "01.06.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7238194458",
    weather: "14°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "30.05.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7228102640",
    weather: "10°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "28.05.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7215097616",
    weather: "13°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "26.05.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7206616018",
    weather: "9°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "23.05.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7191251933",
    weather: "8°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "22.05.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7185431937",
    weather: "10°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "21.05.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7177394820",
    weather: "6°C 🌧️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "18.05.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7164313735",
    weather: "8°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "15.05.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7148340897",
    weather: "12°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "14.05.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7138604952",
    weather: "8°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "11.05.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7126516426",
    weather: "10°C 🌤️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "10.05.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7120778060",
    weather: "6°C 🌧️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "08.05.2022",
    distance: 8,
    link: "https://www.strava.com/activities/7105929208",
    weather: "7°C ⛅",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "07.05.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7100542664",
    weather: "8°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "05.05.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7091241806",
    weather: "12°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "04.05.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7085101438",
    weather: "10°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "03.05.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7080301908",
    weather: "12°C 🌤️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "30.04.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7064292808",
    weather: "6°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "28.04.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7054340744",
    weather: "5°C ⛅",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "27.04.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7047760658",
    weather: "1°C 🌨️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "25.04.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7037760383",
    weather: "10°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "23.04.2022",
    distance: 7,
    link: "https://www.strava.com/activities/7025744146",
    weather: "7°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "21.04.2022",
    distance: 6,
    link: "https://www.strava.com/activities/7018062896",
    weather: "14°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "20.04.2022",
    distance: 10,
    link: "https://www.strava.com/activities/7013415297",
    weather: "15°C ☀️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "18.04.2022",
    distance: 5,
    link: "https://www.strava.com/activities/7000785957",
    weather: "5°C ☀️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "17.04.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6994478174",
    weather: "2°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "16.04.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6989097767",
    weather: "6°C ⛅",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "14.04.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6979122832",
    weather: "2°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "12.04.2022",
    distance: 5,
    link: "https://www.strava.com/activities/6970381802",
    weather: "5°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "10.04.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6957717339",
    weather: "4°C ⛅",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "09.04.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6952358581",
    weather: "2°C 🌤️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "05.04.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6936860634",
    weather: "2°C 🌙",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "04.04.2022",
    distance: 5,
    link: "https://www.strava.com/activities/6931758642",
    weather: "-1°C 🌙",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "01.04.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6914463773",
    weather: "3°C ☀️",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "29.03.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6901782564",
    weather: "2°C ⛅",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "27.03.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6889076010",
    weather: "4°C ☁️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "26.03.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6883433035",
    weather: "5°C 🌤️",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "23.03.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6869229698",
    weather: "6°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "21.03.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6860583904",
    weather: "0°C 🌙",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "18.03.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6842402649",
    weather: "7°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "16.03.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6832481401",
    weather: "2°C ☁️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "07.03.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6821944679",
    weather: "5°C ☀️",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "05.03.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6811986838",
    weather: "6°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "09.03.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6796617253",
    weather: "3°C 🌤️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "07.03.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6788793357",
    weather: "0°C 🌙",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "05.03.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6707532507",
    weather: "5°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "03.03.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6760810827",
    weather: "5°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "28.02.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6751697969",
    weather: "2°C ☁️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "27.02.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6744184112",
    weather: "-3°C 🌤️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "23.02.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6725696572",
    weather: "5°C ☀️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "21.02.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6717822720",
    weather: "-4°C 🌙",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "19.02.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6707532507",
    weather: "-3°C 🌤️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "17.02.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6696015351",
    weather: "3°C 🌤️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "14.02.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6681429694",
    weather: "0°C 🌧️",
  },
  {
    name: "Strømmen utvidet",
    mapImage: "./img/strommen.png",
    date: "12.02.2022",
    distance: 13,
    link: "https://www.strava.com/activities/6670798475",
    weather: "1°C 🌧️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "31.01.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6609260973",
    weather: "-5°C 🌤️",
  },
  {
    name: "Lørenskog VGS",
    mapImage: "./img/lorenskogvgs.png",
    date: "29.01.2022",
    distance: 6,
    link: "https://www.strava.com/activities/6598877613",
    weather: "4°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "26.01.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6583907897",
    weather: "3°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "24.01.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6547653960",
    weather: "2°C 🌤️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "22.01.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6561410591",
    weather: "-3°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "19.01.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6547653960",
    weather: "2°C 🌧️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "17.01.2022",
    distance: 5,
    link: "https://www.strava.com/activities/6537199496",
    weather: "-3°C ☀️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "15.01.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6527541747",
    weather: "0°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "12.01.2022",
    distance: 5,
    link: "https://www.strava.com/activities/6511305725",
    weather: "2°C ☀️",
  },
  {
    name: "Sørum fritidsgård",
    mapImage: "./img/sorumFritidsgard.png",
    date: "03.01.2022",
    distance: 8,
    link: "https://www.strava.com/activities/6501779771",
    weather: "-3°C ☁️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "03.01.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6495624825",
    weather: "-2°C ☁️",
  },
  {
    name: "Langvannet",
    mapImage: "./img/langvannet.png",
    date: "07.01.2022",
    distance: 5,
    link: "https://www.strava.com/activities/6486469232",
    weather: "-3°C ❄️",
  },
  {
    name: "Strømmen",
    mapImage: "./img/strommen.png",
    date: "05.01.2022",
    distance: 10,
    link: "https://www.strava.com/activities/6475729619",
    weather: "-8°C ☀️",
  },
  {
    name: "Lørenskog Stasjon",
    mapImage: "./img/lorenskogStasjon.png",
    date: "03.01.2022",
    distance: 7,
    link: "https://www.strava.com/activities/6465637836",
    weather: "0°C ☁️",
  },
  {
    name: "AHUS",
    mapImage: "./img/ahus.png",
    date: "01.01.2022",
    distance: 9,
    link: "https://www.strava.com/activities/6456288414",
    weather: "-4°C ❄️",
  },
];

export default CardData;
